/** A Vault asset import's status, derived from its files' statuses. */
export enum VeevaVaultAssetImportStatus {
	/** At least one file can still be attempted. */
	IN_PROGRESS = 'in_progress',
	/** Every file is `success`. */
	COMPLETED = 'completed',
	/** Every file is final and at least one is `failure`. */
	FAILED = 'failed',
}

/** What a queued import request asks for. */
export enum VeevaVaultImportAction {
	/** Import the asset code unless it is already recorded. */
	START = 'start',
	/** Queue the finally failed files again; a start when nothing is recorded. */
	RETRY = 'retry',
}

/** One imported Vault file's lifecycle. `failure` is final only once its attempts are exhausted. */
export enum VeevaVaultFileImportStatus {
	PENDING = 'pending',
	DOWNLOADING = 'downloading',
	SUCCESS = 'success',
	FAILURE = 'failure',
}

/** Where a Vault file's copy attempts run, chosen from its size and kept for every later attempt. */
export enum VeevaVaultFileRunner {
	/** The queue consumer Lambda, bounded by Lambda's 15 minutes. */
	LAMBDA = 'lambda',
	/** A Fargate task the consumer starts, bounded only by the copy deadline (ADR-0043). */
	TASK = 'task',
}

/** The Vault object a sold-in question names, which is also the documents' field that records it. */
export enum VeevaVaultSoldInObject {
	PRODUCT = 'product__v',
	/** Sold where any of its products is. */
	PRODUCT_FAMILY = 'product_family__v',
	/** A global brand, counted by the brand its documents record. */
	BRAND = 'global_product__c',
}
